import {Box, Divider, Stack, Grid, Typography, Card, CardActionArea, useTheme, Button, FormControl, Select, InputLabel, MenuItem, Popover} from "@mui/material";
import {urls} from "@routes";
import { useNavigate } from "react-router-dom";
import {
	FontDownloadOff,
	WavingHand,
	Domain,
	Language,
	AppBlocking,
	DeviceHub,
	Security,
	Poll,
	Hub,
	BlockSharp,
	LocalFireDepartment,
    QuestionAnswer
} from "@mui/icons-material";

export default function AdminManageSystem() {
	const theme = useTheme();
	const navigate = useNavigate();
    const MANAGE_SYSTEM_ITEMS = [
        {
            title: "Spam Words",
            description: "Manage words flagged as spam",
            icon: <FontDownloadOff />,
            route: urls.adminSpamWords,
        },
        {
            title: "Salutation Words",
            description: "Configure allowed salutations",
            icon: <WavingHand />,
            route: urls.adminSalutationWords,
        },
        {
            title: "Blacklist Domains",
            description: "Blocked sending domains",
            icon: <Domain />,
            route: urls.adminBlacklist,
        },
        {
            title: "Allowed TLDs",
            description: "Manage allowed top-level domains",
            icon: <Language />,
            route: urls.adminAllowedTLDs,
        },
        {
            title: "Blocked Email Domains",
            description: "Email domains restricted from usage",
            icon: <AppBlocking />,
            route: urls.adminBlockedEmailDomains,
        },
        {
            title: "Integrations",
            description: "Third-party integrations",
            icon: <DeviceHub />,
            route: urls.adminIntegrations,
        },
        {
            title: "Spam Checker",
            description: "Email spam analysis tool",
            icon: <Security />,
            route: urls.adminSpamChecker,
        },
        {
            title: "Surveys",
            description: "User feedback & surveys",
            icon: <Poll />,
            route: urls.adminSurveys,
        },
        {
            title: "NS Settings",
            description: "Domain name server settings",
            icon: <Hub />,
            route: urls.adminNsSetting,
        },
        {
            title: "Burnt Domain Patterns",
            description: "Bounce patterns that flag a sending domain as burnt",
            icon: <LocalFireDepartment />,
            route: urls.adminBurntPatterns,
        },
		{
            title: "Manage Block Emails",
            description: "Unsubscribe and Bad Email settings",
            icon: <BlockSharp />,
            route: urls.adminBlockEmails,
        },
        {
            title: "Onboarding Question",
            description: "Single Onboarding Question",
            icon: <QuestionAnswer />,
            route: urls.adminOnboardingQuestion,
        },
    ];

	return (
		<Stack spacing={3} sx={{ pb: 4 }}>
			<Typography variant="h5" fontWeight="bold">
				Manage System
			</Typography>

			<Typography color="text.secondary">
				System-level configurations and internal admin tools
			</Typography>

			<Divider />

			<Grid container spacing={2} sx={{ pr: 4 }}>
				{MANAGE_SYSTEM_ITEMS.map((item) => (
					<Grid item xs={12} sm={6} md={4} key={item.title}>
						<Card
							sx={{
								height: "100%",
								borderRadius: 2,
								transition: "0.2s",
								"&:hover": {
									boxShadow: theme.shadows[6],
									transform: "translateY(-2px)",
								},
							}}
						>
							<CardActionArea
								sx={{ p: 2, height: "100%" }}
								onClick={() => navigate(item.route)}
							>
								<Stack spacing={1}>
									<Box
										sx={{
											color: theme.palette.primary.main,
											fontSize: 32,
										}}
									>
										{item.icon}
									</Box>

									<Typography fontWeight={600}>
										{item.title}
									</Typography>

									<Typography variant="body2" color="text.secondary">
										{item.description}
									</Typography>
								</Stack>
							</CardActionArea>
						</Card>
					</Grid>
				))}
			</Grid>
		</Stack>
	);
}
